



















































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeOrcamentoStore from '@/components/Backoffice/Store/BackofficeOrcamentoStore'
import EventBus from '@/plugins/EventBus'
import { DateTime } from 'luxon'
import { OrcamentoAcaoEnum, SituacaoEnum } from '@/types/_'

@Component
export default class ComponentBackofficeOrcamentoAnexo extends Vue {
  $refs!: {
    dialogDataValidadeOrcamentoParticularAvulso: any,
    dateA: any,
  }

  dataValidadeOrcamentoParticularAvulsoEnviada = false

  loadDeleteAnexo: string = ''
  loadUpload: boolean = false

  showModalDataValidadeOrcamentoParticularAvulso = false

  dataValidadeOrcamentoParticularAvulso: string | null = null
  dataValidadeOrcamentoRules = [v => !!v || 'Campo Obrigatório']

  get dataValidadeOrcamentoText() {
    if (!['', null, undefined].includes(this.dataValidadeOrcamentoParticularAvulso)) {
      return DateTime.fromISO(this.dataValidadeOrcamentoParticularAvulso).toFormat('dd/LL/yyyy')
    }
    return null
  }

  get hospitalFazOrcamentoAntesDoAgendamento() {
    return this.getBackofficeGlobalStore.solicitacao.hospital
      && this.getBackofficeGlobalStore.solicitacao.hospital.hospitalFazOrcamentoAntesDoAgendamento
  }

  get uploadDisabled() {
    // if (this.hospitalFazOrcamentoAntesDoAgendamento) {
    //   return [0, undefined].includes(this.getBackofficeGlobalStore.solicitacao.valorOrcamentoParticular)
    // }

    return false
  }

  // Alterar para flag criadaComoOrcamentoParticularAvulso quando a api colocar a flag no get by id
  get canShowDataValidadeOrcamentoParticularAvulso() {
    return this.getBackofficeGlobalStore.solicitacao.criadaComoOrcamentoParticularAvulso
  }

  get loadingDeleteAnexo() {
    return this.loadDeleteAnexo
  }

  set loadingDeleteAnexo(value: string) {
    this.loadDeleteAnexo = value
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeOrcamentoStore() {
    return getModule(BackofficeOrcamentoStore, this.$store)
  }

  get getTemplate() {
    return this.getBackofficeGlobalStore.template.formulario
  }

  get getLaudos() {
    return this.getBackofficeOrcamentoStore.anexo
  }

  set getLaudos(value: any) {
    this.getBackofficeOrcamentoStore.setAnexo(value)
  }

  async inputFileOrcamento(newFile, oldFile) {
    // if (this.hospitalFazOrcamentoAntesDoAgendamento && [0, undefined].includes(this.getBackofficeGlobalStore.solicitacao.valorOrcamentoParticular)) {
    //   EventBus.$emit('setSnackbar', { show: true, text: 'O campo valor do orçamento é obrigatório', icon: 'warning', color: '#C62828' })
    //   return
    // }

    this.loadingUpload = true

    if (this.canShowDataValidadeOrcamentoParticularAvulso && !this.dataValidadeOrcamentoParticularAvulso) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo Data de validade do orçamento é obrigatório', icon: 'warning', color: '#C62828' })
      this.loadingUpload = false
      return
    }

    if (newFile.identifier) {
      this.loadingUpload = false
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)

    const header: any = {
      'Content-Type': 'multipart/form-data',
    }

    const params: any = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      form,
      header,
    }

    const response: any = await this.getBackofficeOrcamentoStore.uploadAnexos(params)
    if (response.status === 200) {
      // eslint-disable-next-line no-param-reassign
      newFile.identifier = response.data[0].id
      // eslint-disable-next-line no-param-reassign
      newFile.url = response.data[0].url
      this.getLaudos = newFile

      await this.enviaOrcamentoAcao()

      EventBus.$emit('setSnackbar', { show: true, text: 'Orçamento anexado com sucesso.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao anexar o documento.', icon: 'warning', color: '#C62828' })
    }

    this.loadingUpload = false
  }

  async enviaOrcamentoAcao() {
    let acao = OrcamentoAcaoEnum.OrcamentoEnviaOrcamento

    // Caso seja um orçamento avulso e já tenha sido enviado, precisa trocar a ação para atualizar
    if (this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.OrcamentoParticularAvulsoEnviado) {
      acao = OrcamentoAcaoEnum.OrcamentoAtualizaOrcamento
    }

    const dataOrcamentoAcao = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      acaoOrcamento: acao,
      dataValidadeOrcamentoParticularAvulso: this.dataValidadeOrcamentoParticularAvulso || undefined,
      valorOrcamentoParticular: this.getBackofficeGlobalStore.solicitacao.valorOrcamentoParticular,
    }

    Object.entries(dataOrcamentoAcao).forEach(([key, value]) => {
      if ([0, '', null, undefined].includes(value as any)) delete dataOrcamentoAcao[key]
    })

    const res = await this.getBackofficeOrcamentoStore.backofficeOrcamentoEnviaOrcamento(dataOrcamentoAcao)
    if (res.success) {
      this.dataValidadeOrcamentoParticularAvulsoEnviada = true
      EventBus.$emit('setSnackbar', { show: true, text: 'Orçamento atualizado com sucesso.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao atualizar o orçamento.', icon: 'warning', color: '#C62828' })
    }
  }

  async checkNeedCallEnviaOrcamentoAcao() {
    if (this.dataValidadeOrcamentoParticularAvulso && !this.dataValidadeOrcamentoParticularAvulsoEnviada) {
      return this.enviaOrcamentoAcao()
    }
    return undefined
  }

  async deleteAnexo(value) {
    this.loadingDeleteAnexo = value.identifier

    const request = await this.getBackofficeOrcamentoStore.deleteLaudo({
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      id: value.identifier,
    })

    if (request.success) {
      if (request.success) {
        const removeArray: any[] = []

        for (let i = 0; i < this.getLaudos.length; i++) {
          if (this.getLaudos[i].identifier === value.identifier) {
            removeArray.push(i)
          }
        }

        for (let i = 0; i < removeArray.length; i++) {
          this.getLaudos.splice(removeArray[i], 1)
        }
      }
    }
    this.loadingDeleteAnexo = ''
  }
}
